import { render } from "./sRadio.vue?vue&type=template&id=1673222a"
import script from "./sRadio.vue?vue&type=script&lang=js"
export * from "./sRadio.vue?vue&type=script&lang=js"

import "./sRadio.vue?vue&type=style&index=0&id=1673222a&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__